import { lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import PublicOnlyRoute from "@/components/auth/PublicOnlyRoute";
import AppLayout from "@/components/layout/AppLayout";

// Public layout + landing
const PublicLayout = lazy(() => import("@/components/layout/PublicLayout/PublicLayout"));
const LandingPage = lazy(() => import("@/pages/landing"));

// Auth pages
const SignupPage = lazy(() => import("@/pages/auth/Signup"));
const LoginPage = lazy(() => import("@/pages/auth/Login"));
const VerifyEmailPage = lazy(() => import("@/pages/auth/VerifyEmail"));
const MagicLinkVerifyPage = lazy(() => import("@/pages/auth/MagicLinkVerify"));

// Legal pages
const TermsPage = lazy(() => import("@/pages/legal/TermsPage"));
const PrivacyPage = lazy(() => import("@/pages/legal/PrivacyPage"));

// Thank-you page
const ThankYouPage = lazy(() => import("@/pages/landing/thankYou"));

// App pages
const Dashboard = lazy(() => import("@/pages/dashboard"));
const AudioCapture = lazy(() => import("@/pages/audio"));
const DocumentList = lazy(() => import("@/pages/document"));
const TicketHistory = lazy(() => import("@/pages/tickets"));
const Integrations = lazy(() => import("@/pages/integrations"));
const Billing = lazy(() => import("@/pages/billing"));
const Settings = lazy(() => import("@/pages/settings"));

// Error pages
const NotFound = lazy(() => import("@/pages/errors/NotFound"));

const AppRoutes = () => {
  return (
    <Routes>
        {/* Public routes — wrapped in PublicLayout (header + footer) */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<LandingPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
        </Route>

        {/* Public-only routes — commented out pre-launch, uncomment for local dev */}
        {/* <Route
          path="/signup"
          element={
            <PublicOnlyRoute>
              <SignupPage />
            </PublicOnlyRoute>
          }
        />
        <Route
          path="/login"
          element={
            <PublicOnlyRoute>
              <LoginPage />
            </PublicOnlyRoute>
          }
        />
        <Route
          path="/verify-email"
          element={
            <PublicOnlyRoute>
              <VerifyEmailPage />
            </PublicOnlyRoute>
          }
        />
        <Route
          path="/verify-login"
          element={
            <PublicOnlyRoute>
              <MagicLinkVerifyPage />
            </PublicOnlyRoute>
          }
        /> */}

        {/* Protected app routes — wrapped in AppLayout */}
        <Route
          element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/app/dashboard" element={<Dashboard />} />
          <Route path="/app/audio" element={<AudioCapture />} />
          <Route path="/app/documents" element={<DocumentList />} />
          <Route path="/app/tickets" element={<TicketHistory />} />
          <Route path="/app/integrations" element={<Integrations />} />
          <Route path="/app/billing" element={<Billing />} />
          <Route path="/app/settings" element={<Settings />} />
        </Route>

        {/* 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
  );
};

export default AppRoutes;
